import { ComparisonOperators } from "utils/constants";

export class MediaFilterModel {
    constructor(obj) {
        this.keyword = '';
        this.sak = -1;
        this.star = -1;
        this.styles = [];
        this.tags = [];
        this.catalogue = { label: '', value: { since: null, until: null } };
        this.groupBy = '';
        this.psdLoaded = '';
        this.status = {taskStatus:''}
        this.starComparison = ComparisonOperators.EQUAL;
        this.colourTag = []
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
